import React, { PropTypes } from 'react';
import cn from 'classnames';

import './styles.scss';

export function Footerbutton(props) {
  const iconClasses = cn(props.icon, props.count > 0 ? 'bubble' : null);
  return (
    <div
      className={`footerbutton ${props.selection}`}
      onClick={event => props.onClick(event)}
    >
      <i className={iconClasses} data-count={props.count} />
      <p>{props.text}</p>
    </div>
  );
}

Footerbutton.propTypes = {
  selection: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  count: PropTypes.number,
};


export default Footerbutton;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/footer/footerbutton/main.jsx